<header-actions class="header-cs">
  <div class="title-wrap">
    <h4 class="map-title-cs">{{ 'select_site_location_tr' | translate }}</h4>
    <span class="map-hint-inline" [attr.aria-live]="'polite'">{{ hintText }}</span>
    <span class="map-hint-inline" data-testid="traces-geo-pending" *ngIf="tracesGeoPending">{{
      'traces_geometry_pending_tr' | translate
    }}</span>
  </div>

  <div class="button-row">
    <button
      type="button"
      class="icon-btn"
      data-testid="traces-geo-toggle"
      [class.active]="tracesGeoVisible"
      [attr.aria-pressed]="tracesGeoVisible"
      [title]="'traces_geometry_toggle_tr' | translate"
      (click)="toggleTracesGeometry()"
    >
      <mat-icon>layers</mat-icon>
    </button>
    <button (click)="openHelp()" class="icon-btn" type="button" title="Help">
      <mat-icon>help</mat-icon>
    </button>
    <button
      type="button"
      class="icon-btn"
      data-testid="map-upload-button"
      title="Upload File (.geojson,.json,.zip,.csv,.xls,.xlsx,.qgz,.gpx)"
      (click)="handleUploadClick()"
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 17V10m0 0l3 3m-3-3l-3 3" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M16 7H8" stroke="#000" stroke-width="1.5" stroke-linecap="round" />
        <path
          d="M22 12c0 4.714 0 7.071-1.464 8.536C19.071 22 16.714 22 12 22s-7.071 0-8.536-1.464C2 19.071 2 16.714 2 12c0-4.714 0-7.071 1.464-8.536C4.929 2 7.286 2 12 2s7.071 0 8.536 1.464C21.51 4.438 21.836 5.807 21.945 8"
          stroke="#000"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    </button>

    <button class="icon-btn" type="button" title="Download Shape" (click)="downloadAllPolygonsAsGeoJSON()">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 7v7m0 0l3-3m-3 3l-3-3" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M16 17H8" stroke="#000" stroke-width="1.5" stroke-linecap="round" />
        <path
          d="M22 12c0 4.714 0 7.071-1.464 8.536C19.071 22 16.714 22 12 22s-7.071 0-8.536-1.464C2 19.071 2 16.714 2 12c0-4.714 0-7.071 1.464-8.536C4.929 2 7.286 2 12 2s7.071 0 8.536 1.464C21.51 4.438 21.836 5.807 21.945 8"
          stroke="#000"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    </button>

    <button class="icon-btn" type="button" data-testid="map-save-close-button" title="Save and Close" (click)="saveAndClose()">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19 5L4.99998 19M5.00001 5L19 19"
          stroke="#000000"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </svg>
    </button>
  </div>
</header-actions>

<!-- Hidden file input used by Upload button -->
<input
  #fileInput
  type="file"
  accept=".geojson,.json,.zip,.csv,.xls,.xlsx,.qgz,.gpx"
  style="display: none"
  (change)="onFileSelected($event)"
/>

<mat-dialog-content class="map-content-cs">
  <div #mapContainer id="map" class="height-100"></div>
  <div class="upload-overlay" *ngIf="isUploading">
    <div class="upload-panel">
      <div class="upload-spinner" aria-hidden="true"></div>
      <div class="upload-text">
        <div class="upload-title">{{ 'Uploading_file_tr' | translate }}</div>
        <div class="upload-progress">{{ uploadProgress }}%</div>
        <div class="upload-note">{{ 'Large_GeoJSONs_can_take_a_moment_to_load_tr' | translate }}</div>
      </div>
    </div>
  </div>
</mat-dialog-content>
